export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";